import { appFeedbackOutput, feedbackPromptOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { getJson, sendJson, withQuery, } from "../core/request";
/**
 * The rating prompt and the satisfaction check (`D251`): the read that says
 * whether a workout's summary asks, and the write of one tap.
 *
 * The key is `["feedback","prompt",sessionId]` — NOT under `workout`: every
 * set and session write invalidates that prefix, and a prompt refetched while
 * the person is answering it could vanish under their thumb. The write
 * invalidates exactly this prefix, so the answered card goes away and the
 * next summary asks afresh.
 */
export const feedbackKeys = {
    all: ["feedback"],
    prompt: (sessionId) => ["feedback", "prompt", sessionId],
};
/** `GET /me/feedback/prompt?sessionId=` — `prompt` is a string so a newer
 *  question decodes; the app draws only those it has copy for. */
export function fetchFeedbackPrompt(api, sessionId, init) {
    return getJson(api, withQuery(TRAINING_ROUTES.feedbackPrompt, { sessionId }), feedbackPromptOutput, init);
}
/**
 * `POST /me/feedback` — 201 for a new tap, 200 for a resend of the same
 * `input.id`. Mint the id once per drawn prompt with the `uuidv7` helper and
 * resend the same one, or a retry is a second answer in the average.
 */
export function submitAppFeedback(api, input) {
    return sendJson(api, "POST", TRAINING_ROUTES.feedback, input, appFeedbackOutput);
}
/** Whether this workout's summary asks something. Asked once per summary:
 *  the answer moves only when a tap is stored, which invalidates it. */
export function feedbackPromptOptions(api, sessionId) {
    return {
        queryFn: ({ signal }) => fetchFeedbackPrompt(api, sessionId, { signal }),
        queryKey: feedbackKeys.prompt(sessionId),
        staleTime: Number.POSITIVE_INFINITY,
    };
}
export function appFeedbackMutation(api) {
    return {
        invalidates: [feedbackKeys.all],
        mutationFn: (input) => submitAppFeedback(api, input),
        mutationKey: ["feedback", "submit"],
    };
}
//# sourceMappingURL=app-feedback.js.map